import { IconProps } from '@/types';
import React from 'react';

export const ChevronDown = ({
  color = 'white',
  height = '7',
  width = '12',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.699219 0.700195L5.69922 5.7002L10.6992 0.700195"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
